import { useMemo } from 'react';

import { useStores } from '../../../stores/useStores';
import type { StampCardWidgetDataType, WidgetEntry } from '../types';

export function useStampCardWidgets() {
  const { stampCardStore } = useStores();
  const { stampCardFlag, currentStampCard } = stampCardStore;

  const stampCardWidgets: StampCardWidgetDataType[] = useMemo(() => {
    if (!stampCardFlag || !currentStampCard) {
      return [];
    }
    return [
      {
        key: 'stampCard',
        event: currentStampCard,
        dataTestId: 'stamp-card-widget',
      },
    ];
  }, [stampCardFlag, currentStampCard]);

  return useMemo(
    () => stampCardWidgets.map((data): WidgetEntry<'stampCard'> => ({ data, type: 'stampCard', id: data.key })),
    [stampCardWidgets],
  );
}
